var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
define(["require", "exports", "hypo_elements/Typescripts/Mustache/Mustache"], function (require, exports, HypoportMustache) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.renderAgentBusinessCardHead = void 0;
    HypoportMustache = __importStar(HypoportMustache);
    function renderAgentBusinessCardHead($template, officeAllocation) {
        return HypoportMustache.render($template, {
            agent: officeAllocation.agent,
            office: officeAllocation.office,
            title: "".concat(officeAllocation.agent.title, " f\u00FCr ").concat(window.hypoport.produktsparte),
            rating: officeAllocation.agent.rating,
            formattedRating: officeAllocation.agent.formattedRating,
            numberOfRatings: officeAllocation.agent.numberOfRatings,
            recommendationPercent: officeAllocation.agent.recommendationPercent
        });
    }
    exports.renderAgentBusinessCardHead = renderAgentBusinessCardHead;
});
